import React, { Component } from 'react'
import get from 'lodash.get'
import { CtaBtn } from '../../../components'
import { Constants } from '@sukiai/components'
import InputMask from 'react-input-mask'
import {
  hasMinimumChar,
  hasNumber,
  hasUpperCase,
  hasLowerCase,
  doesNotContainUsername,
  isValidEmail,
  isValidPassword,
  snakeCapsToEnglish
} from '@sukiai/utils'
import {
  Form,
  Select,
  ButtonLink,
  Input,
  InputGroup,
  InputRow,
  AddAnotherSpecialty,
  InputContainer,
  InputErrorIcon,
  EMRSupportText
} from '../components/styles/form'
import Requirements from '../components/Requirements'
import AgreementCheckbox from '../components/AgreementCheckbox'

const { SPECIALTY_TYPE, TIMEZONES } = Constants
const SPECIALTIES_ARR = Object.keys(SPECIALTY_TYPE)

const EMR_SUPPORT = {
  IS_SUPPORTED: 'IS_SUPPORTED',
  WILL_SUPPORT: 'WILL_SUPPORT',
  NOT_SUPPORTED: 'NOT_SUPPORTED'
}

// TODO update values of EMRTypes
export const EMR_TYPE = [
  { name: 'AllScripts', value: 'ALLSCRIPTS', support: EMR_SUPPORT.WILL_SUPPORT },
  { name: 'Athena', value: 'ATHENA', support: EMR_SUPPORT.IS_SUPPORTED },
  { name: 'Cerner', value: 'CERNER', support: EMR_SUPPORT.WILL_SUPPORT },
  { name: 'eCW', value: 'UNKNOWN', support: EMR_SUPPORT.WILL_SUPPORT },
  { name: 'Elation', value: 'ELATION', support: EMR_SUPPORT.IS_SUPPORTED },
  { name: 'Epic', value: 'EPIC', support: EMR_SUPPORT.WILL_SUPPORT },
  { name: 'Greenway', value: 'GREENWAY', support: EMR_SUPPORT.NOT_SUPPORTED },
  { name: 'NextGen', value: 'NEXTGEN', support: EMR_SUPPORT.NOT_SUPPORTED },
  { name: 'Meditech', value: 'MEDITECH', support: EMR_SUPPORT.NOT_SUPPORTED },
  { name: 'Other', value: 'UNKNOWN', support: EMR_SUPPORT.NOT_SUPPORTED }
]

class OnboardForm extends Component {
  state = {
    isPasswordHidden: true,

    firstName: this.props.initialValues.person?.firstName,
    lastName: this.props.initialValues.person?.lastName,
    suffix: this.props.initialValues.person?.suffix,
    practiceName: this.props.initialValues.practiceName,
    phoneNumber: this.props.initialValues.phoneNumber,
    timezone: this.props.initialValues.timezone,
    email: this.props.initialValues.email,
    emr: '',
    specialties: [''],
    password: '',
    confirmPassword: '',

    touched: {
      firstName: false,
      lastName: false,
      practiceName: false,
      phoneNumber: false,
      specialties: false,
      emr: false,
      email: false,
      timezone: false,
      password: false,
      confirmPassword: false
    }
  }

  touchField = field => e => {
    this.setState({
      touched: { ...this.state.touched, [field]: true }
    })
  }

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  handlePhoneChange = e => {
    // remove mask, remove leading 1 -- kinda hacky
    const val = e.target.value.replace(/[^\d]/g, '')
    this.setState({ [e.target.name]: val })
  }

  onSubmitClick = e => {
    // touch all inputs for validation
    const touched = { ...this.state.touched }
    Object.keys(touched).forEach(field => {
      touched[field] = true
    })
    this.setState({ touched })

    // shake on error
    const errors = this.checkFieldErrors()
    const isInvalid = Object.keys(errors).some(x => errors[x])

    if (isInvalid) {
      this.setSubmissionBtnErr()
    }
  }

  handleSubmit = e => {
    e.preventDefault()

    const { handleFormCompletion } = this.props

    const {
      firstName,
      lastName,
      suffix,
      phoneNumber,
      specialties,
      timezone,
      password,
      emr,
      email,
      practiceName
    } = this.state

    // do final check
    const errors = this.checkFieldErrors()
    const isInvalid = Object.keys(errors).some(x => errors[x])
    if (isInvalid) {
      this.setSubmissionBtnErr()

      console.debug('ERROR OBJECT' + errors)
      return
    }

    // dedupe + sort specialties array
    const filteredSpecialties = [...new Set(specialties)].filter(s => !!s)

    // get emr value
    const emrValue = get(EMR_TYPE.find(e => emr === e.name), 'value', 'UNKNOWN')

    // package for api
    const formValues = {
      firstName,
      lastName,
      suffix,
      phoneNumber,
      specialties: filteredSpecialties,
      timezone,
      password,
      emr: emrValue,
      email,
      practiceName
    }

    handleFormCompletion(formValues)
  }

  setSubmissionBtnErr = () => {
    // set error then reset
    this.setState({ onSubmissionError: true }, () => {
      setTimeout(() => {
        this.setState({ onSubmissionError: false })
      }, 1000)
    })
  }

  checkFieldErrors = () => {
    const { hasOrg } = this.props
    const {
      firstName,
      lastName,
      phoneNumber,
      practiceName,
      timezone,
      emr,
      email,
      password,
      confirmPassword
    } = this.state

    // true means invalid
    return {
      firstName: firstName.trim().length === 0,
      lastName: lastName.trim().length === 0,
      practiceName: practiceName.trim().length === 0,
      phoneNumber: phoneNumber.trim().length === 0,
      timezone: timezone.trim().length === 0,
      emr: !hasOrg && emr.trim().length === 0,
      email: !isValidEmail(email),
      password: !isValidPassword(password, email),
      confirmPassword:
        !isValidPassword(password, email) || password !== confirmPassword
    }
  }

  checkPasswordErrors = () => {
    const { email, password } = this.state

    // true means invalid
    return {
      hasUpperCase: !hasUpperCase(password),
      hasLowerCase: !hasLowerCase(password),
      hasNumber: !hasNumber(password),
      hasMinimumChar: !hasMinimumChar(password),
      doesNotContainUsername: !doesNotContainUsername(password, email)
    }
  }

  handleToggleShowPassword = e => {
    e.preventDefault()

    this.setState({ isPasswordHidden: !this.state.isPasswordHidden })
  }

  handleSpecialtyInput = e => {
    e.preventDefault()
    const specialties = [...this.state.specialties]
    specialties.push('')
    this.setState({ specialties })
  }

  handleSpecialtyChange = (e, index) => {
    e.preventDefault()
    const value = e.target.value
    const specialties = [...this.state.specialties]
    specialties[index] = value

    this.setState({ specialties })
  }

  renderSpecialties = () => {
    const { specialties } = this.state

    return specialties.map((specialty, i) => (
      <Select
        key={i}
        name='specialties'
        value={specialty}
        onChange={e => this.handleSpecialtyChange(e, i)}
      >
        <option value=''>Select Specialty</option>
        {SPECIALTIES_ARR.map(s => (
          <option key={s} value={s}>
            {snakeCapsToEnglish(s)}
          </option>
        ))}
      </Select>
    ))
  }

  renderTimezoneOptions = () => {
    return TIMEZONES.map(timezone => (
      <option key={timezone.value} value={timezone.value}>
        {timezone.name}
      </option>
    ))
  }

  renderEMRSupport = () => {
    const { emr } = this.state

    const currentEMR = EMR_TYPE.find(e => emr === e.name)
    const currentEMRName = get(currentEMR, 'name')
    const currentEMRSupport = get(currentEMR, 'support')

    switch (currentEMRSupport) {
      case EMR_SUPPORT.IS_SUPPORTED:
        return (
          <EMRSupportText>
            Integrating with {currentEMRName} only takes a few days. Our team will contact you with details. In the meantime, you can get started without integration.
          </EMRSupportText>
        )
      case EMR_SUPPORT.WILL_SUPPORT:
        return (<EMRSupportText>Integrating with {currentEMRName} can take a while. Our team will contact you with details. In the meantime, you can get started without integration.</EMRSupportText>
        )

      case EMR_SUPPORT.NOT_SUPPORTED:
        // special case for other
        if (currentEMRName === 'Other') {
          return (<EMRSupportText>Suki integrates with a few select EMRs. You can get started without integration.</EMRSupportText>)
        } else {
          return (<EMRSupportText>Suki does not integrate with {currentEMRName}. You can still get started without integration.</EMRSupportText>)
        }
      default:
        return null
    }
  }

  renderEMRSelect = () => {
    const { emr } = this.state
    // EMR_TYPE
    return (
      <Select
        name='emr'
        value={emr}
        onChange={this.handleChange}
        required
      >
        <option value=''>Select EMR</option>
        {EMR_TYPE.map(e => (
          <option key={e.name} value={e.name}>
            {e.name}
          </option>
        ))}
      </Select>

    )
  }

  render () {
    // need to disable practiceName, email if not from gcp
    const { hasOrg, isFormLoading, isPracticePrefilled } = this.props
    const {
      firstName,
      lastName,
      touched,
      suffix,
      practiceName,
      phoneNumber,
      timezone,
      email,
      password,
      confirmPassword,
      isPasswordHidden
    } = this.state

    const errors = this.checkFieldErrors()
    const isFieldError = field => {
      const error = errors[field]
      const shouldShow = touched[field]

      return error ? shouldShow : false
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <h2>{hasOrg ? 'Please register for a Suki account' : 'Suki registration'} </h2>

        <InputRow>
          <InputContainer>
            <Input
              type='text'
              name='firstName'
              placeholder='First Name'
              value={firstName}
              onChange={this.handleChange}
              onBlur={this.touchField('firstName')}
              autoComplete='none'
              required
            />
            {isFieldError('firstName') && <InputErrorIcon />}
          </InputContainer>

          <InputContainer>
            <Input
              type='text'
              name='lastName'
              placeholder='Last Name'
              value={lastName}
              onChange={this.handleChange}
              autoComplete='none'
              onBlur={this.touchField('lastName')}
              required
            />
            {isFieldError('lastName') && <InputErrorIcon />}
          </InputContainer>

          <InputContainer>
            <Input
              name='suffix'
              value={suffix}
              placeholder='Suffix'
              onChange={this.handleChange}
              autoComplete='none'
            />
          </InputContainer>
        </InputRow>

        {!hasOrg && (
          <InputContainer>
            <Input
              type='text'
              name='practiceName'
              placeholder='Practice Name'
              value={practiceName}
              onChange={this.handleChange}
              onBlur={this.touchField('practiceName')}
              autoComplete='none'
              required
              disabled={isPracticePrefilled}
            />
            {isFieldError('practiceName') && <InputErrorIcon />}
          </InputContainer>
        )}

        <InputContainer>
          <InputMask
            className='onboard-input'
            type='tel'
            name='phoneNumber'
            placeholder='Phone Number'
            defaultValue={phoneNumber}
            onChange={this.handlePhoneChange}
            onBlur={this.touchField('phoneNumber')}
            mask='+1 (999) 999-9999'
            required
          />
          {isFieldError('phoneNumber') && <InputErrorIcon />}
        </InputContainer>

        <InputContainer>
          {this.renderSpecialties()}
        </InputContainer>

        <AddAnotherSpecialty onClick={this.handleSpecialtyInput}>
          + Add another specialty
        </AddAnotherSpecialty>

        <Select
          name='timezone'
          value={timezone}
          onChange={this.handleChange}
          required
          error={isFieldError('timezone').toString()}
        >
          <option value=''>Select Timezone</option>
          {this.renderTimezoneOptions()}
        </Select>
        {!hasOrg && this.renderEMRSelect()}
        {!hasOrg && this.renderEMRSupport()}

        <InputGroup>
          <Input
            type='email'
            name='email'
            placeholder='email'
            value={email}
            onChange={this.handleChange}
            onBlur={this.touchField('email')}
            autoComplete='none'
            disabled={!!hasOrg}
          />
          {isFieldError('email') && <InputErrorIcon />}
        </InputGroup>

        <InputGroup>
          <Input
            type={isPasswordHidden ? 'password' : 'text'}
            name='password'
            placeholder='Create a password'
            value={password}
            onChange={this.handleChange}
            onFocus={this.touchField('password')}
            required
          />
          <ButtonLink onClick={this.handleToggleShowPassword}>
            {isPasswordHidden ? 'Show' : 'Hide'}
          </ButtonLink>
          {isFieldError('password') && <InputErrorIcon />}
        </InputGroup>

        <Requirements
          passwordTouched={touched.password}
          checkPasswordErrors={this.checkPasswordErrors()}
        />

        <InputGroup>
          <Input
            type={isPasswordHidden ? 'password' : 'text'}
            name='confirmPassword'
            placeholder='Confirm password'
            value={confirmPassword}
            onChange={this.handleChange}
            error={isFieldError('confirmPassword')}
            onBlur={this.touchField('confirmPassword')}
            required
          />
          <ButtonLink onClick={this.handleToggleShowPassword}>
            {isPasswordHidden ? 'Show' : 'Hide'}
          </ButtonLink>
          {isFieldError('confirmPassword') && <InputErrorIcon />}
        </InputGroup>

        <AgreementCheckbox />

        <CtaBtn
          handleClick={this.onSubmitClick}
          isLoading={isFormLoading}
          error={this.state.onSubmissionError}
        >
          Create Account
        </CtaBtn>
      </Form>
    )
  }
}

export default OnboardForm
